
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"saveDistanceGlasses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"glassesPrescriptionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sphericalLeftEye"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sphericalRightEye"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cylindricalLeftEye"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cylindricalRightEye"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"axisLeftEye"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"axisRightEye"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveDistanceGlasses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"glassesPrescriptionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"glassesPrescriptionId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sphericalLeftEye"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sphericalLeftEye"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sphericalRightEye"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sphericalRightEye"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"cylindricalLeftEye"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cylindricalLeftEye"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"cylindricalRightEye"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cylindricalRightEye"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"axisLeftEye"},"value":{"kind":"Variable","name":{"kind":"Name","value":"axisLeftEye"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"axisRightEye"},"value":{"kind":"Variable","name":{"kind":"Name","value":"axisRightEye"}}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":588}};
    doc.loc.source = {"body":"mutation saveDistanceGlasses(\n  $glassesPrescriptionId: ID!\n  $sphericalLeftEye: String\n  $sphericalRightEye: String\n  $cylindricalLeftEye: String\n  $cylindricalRightEye: String\n  $axisLeftEye: String\n  $axisRightEye: String\n) {\n  saveDistanceGlasses(\n    input: {\n      glassesPrescriptionId: $glassesPrescriptionId\n      sphericalLeftEye: $sphericalLeftEye\n      sphericalRightEye: $sphericalRightEye\n      cylindricalLeftEye: $cylindricalLeftEye\n      cylindricalRightEye: $cylindricalRightEye\n      axisLeftEye: $axisLeftEye\n      axisRightEye: $axisRightEye\n    }\n  ) {\n    id\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["saveDistanceGlasses"] = oneQuery(doc, "saveDistanceGlasses");
        
